
.optionWrap {
  position: relative;
  &.optionWrapWithDelete {
    padding-right: 48px;
  }
  &.optionWrapWithDrag {
    padding-left: 24px;
  }
}

.dragHandle {
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 100%;
  cursor: grab;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-self: center;

  &:active {
    cursor: grabbing;
  }
}

.optionDeleteBtn {
  position: absolute;
  top: 8px;
  right: 0;
}
